export const REQUEST_STATE = {
  STATE_PENDING: 'STATE_PENDING',
  STATE_SUCCESS: 'STATE_SUCCESS',
  STATE_FAILURE: 'STATE_FAILURE',
  STATE_INITIAL: 'STATE_INITIAL',
}

export const SET_STATE_KEY = 'SET'
